import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'

import { AppDispatch, RootState } from 'store'
import { getErrorMessage } from 'utils/helpers'
import { fetchContactsThunk } from 'slices/creators/thunk'
import { updateContactTags } from 'services/api/creator-contacts'
import { resetCreatorsState } from 'slices/creators/reducer'
import TagsSelector from './TagsSelector'
import './AddCreatorContactModal.scss'

const HandleCreatorTagsModal: React.FC<{
    isOpen: boolean
    onClose: () => void
    socialAccountId?: string
    initialTags?: string[]
    creatorName?: string
}> = ({ isOpen, onClose, socialAccountId, initialTags = [], creatorName }) => {
    const [processing, setProcessing] = useState(false)
    const [tags, setTags] = useState<string[]>([])
    const dispatch = useDispatch<AppDispatch>()
    const selectedAgencyId = useSelector((state: RootState) => state.auth.selectedAgencyId)
    const filters = useSelector((state: RootState) => state.creators.filters)

    const handleSubmit = async () => {
        if (!selectedAgencyId || !socialAccountId) return
        try {
            setProcessing(true)
            await updateContactTags(selectedAgencyId, socialAccountId, tags)
            toast.success('Creator tags updated successfully.')
            dispatch(resetCreatorsState())
            dispatch(fetchContactsThunk({ force: true, filters: { ...filters, page: 1 } }))
            onClose()
        } catch (error: unknown) {
            toast.error(getErrorMessage(error) || 'Failed to update creator tags. Please try again.')
        } finally {
            setProcessing(false)
        }
    }

    useEffect(() => {
        if (isOpen) {
            setTags(initialTags ?? [])
        }
    }, [isOpen, initialTags])

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className="handle-creator-tags-modal">
            <ModalHeader toggle={onClose}>
                Edit Tags
                {creatorName && (
                    <p className="modal-subtitle text-dark fw-medium mb-0 mt-1">{creatorName}</p>
                )}
            </ModalHeader>
            <ModalBody>
                <label htmlFor="creator-tags" className="form-label">
                    Tags
                </label>
                <TagsSelector value={tags} onChange={setTags} />
            </ModalBody>
            <ModalFooter>
                <button type="button" className="theme-btn btn-primary-outlined" onClick={onClose}>
                    Cancel
                </button>
                <button
                    type="button"
                    className="theme-btn btn-primary"
                    onClick={handleSubmit}
                    disabled={processing || !socialAccountId}
                >
                    {processing ? 'Saving...' : 'Save Tags'}
                </button>
            </ModalFooter>
        </Modal>
    )
}

export default HandleCreatorTagsModal
